export default __webpack_public_path__ + "static/media/smoothie-2.b1b78498.jpeg";